import { RouteKeys } from "models/RouteModels";

export const homeRoutes = {
    [RouteKeys.TRIAGE_LIST]: '/triage-list',
}
